export default __webpack_public_path__ + "static/media/piano5.74271659.png";